var _inherits = require("/opt/build/repo/node_modules/@babel/runtime/helpers/inherits.js");

var _possibleConstructorReturn = require("/opt/build/repo/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");

var _getPrototypeOf = require("/opt/build/repo/node_modules/@babel/runtime/helpers/getPrototypeOf.js");

var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/opt/build/repo/node_modules/@babel/runtime/helpers/createClass.js");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/* eslint-disable max-classes-per-file */
var _require = require('./inline-text-builder'),
    InlineTextBuilder = _require.InlineTextBuilder;

var StackItem = /*#__PURE__*/function () {
  "use strict";

  function StackItem() {
    var next = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

    _classCallCheck(this, StackItem);

    this.next = next;
  }

  _createClass(StackItem, [{
    key: "getRoot",
    value: function getRoot() {
      return this.next ? this.next : this;
    }
  }]);

  return StackItem;
}();

var BlockStackItem = /*#__PURE__*/function (_StackItem) {
  "use strict";

  _inherits(BlockStackItem, _StackItem);

  var _super = _createSuper(BlockStackItem);

  function BlockStackItem(options) {
    var _this;

    var next = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var leadingLineBreaks = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
    var maxLineLength = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;

    _classCallCheck(this, BlockStackItem);

    _this = _super.call(this, next);
    _this.leadingLineBreaks = leadingLineBreaks;
    _this.inlineTextBuilder = new InlineTextBuilder(options, maxLineLength);
    _this.rawText = '';
    _this.stashedLineBreaks = 0;
    _this.isPre = next && next.isPre;
    return _this;
  }

  return _createClass(BlockStackItem);
}(StackItem);

var TableStackItem = /*#__PURE__*/function (_StackItem2) {
  "use strict";

  _inherits(TableStackItem, _StackItem2);

  var _super2 = _createSuper(TableStackItem);

  function TableStackItem() {
    var _this2;

    var next = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

    _classCallCheck(this, TableStackItem);

    _this2 = _super2.call(this, next);
    _this2.rows = [];
    _this2.isPre = next && next.isPre;
    return _this2;
  }

  return _createClass(TableStackItem);
}(StackItem);

var TableRowStackItem = /*#__PURE__*/function (_StackItem3) {
  "use strict";

  _inherits(TableRowStackItem, _StackItem3);

  var _super3 = _createSuper(TableRowStackItem);

  function TableRowStackItem() {
    var _this3;

    var next = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

    _classCallCheck(this, TableRowStackItem);

    _this3 = _super3.call(this, next);
    _this3.cells = [];
    _this3.isPre = next && next.isPre;
    return _this3;
  }

  return _createClass(TableRowStackItem);
}(StackItem);

var TableCellStackItem = /*#__PURE__*/function (_StackItem4) {
  "use strict";

  _inherits(TableCellStackItem, _StackItem4);

  var _super4 = _createSuper(TableCellStackItem);

  function TableCellStackItem(options) {
    var _this4;

    var next = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var maxColumnWidth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;

    _classCallCheck(this, TableCellStackItem);

    _this4 = _super4.call(this, next);
    _this4.inlineTextBuilder = new InlineTextBuilder(options, maxColumnWidth);
    _this4.rawText = '';
    _this4.stashedLineBreaks = 0;
    _this4.isPre = next && next.isPre;
    return _this4;
  }

  return _createClass(TableCellStackItem);
}(StackItem);

var TransformerStackItem = /*#__PURE__*/function (_StackItem5) {
  "use strict";

  _inherits(TransformerStackItem, _StackItem5);

  var _super5 = _createSuper(TransformerStackItem);

  function TransformerStackItem() {
    var _this5;

    var next = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var transform = arguments.length > 1 ? arguments[1] : undefined;

    _classCallCheck(this, TransformerStackItem);

    _this5 = _super5.call(this, next);
    _this5.transform = transform;
    return _this5;
  }

  return _createClass(TransformerStackItem);
}(StackItem);

module.exports = {
  BlockStackItem: BlockStackItem,
  StackItem: StackItem,
  TableCellStackItem: TableCellStackItem,
  TableRowStackItem: TableRowStackItem,
  TableStackItem: TableStackItem,
  TransformerStackItem: TransformerStackItem
};